import styled from '@emotion/styled';

export const InnerBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchBox = styled.div`
  padding: 16px 24px 0px;
`;

export const ListBox = styled.div``;

export const UserInfoItem = styled.div<{ disabled: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  opacity: ${({ disabled }) => disabled && '0.3'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const InfoBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
`;

export const MainData = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.neutral[700]};
  max-width: 355px;
  /* 말줄임표 - 2줄까지 */
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubData = styled.p`
  max-width: 340px;
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.neutral[400]};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectedUserNumber = styled.div``;

export const SelectedChipsBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  min-height: 68px;
  max-height: 68px;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 4px 24px;
  gap: 8px;
  overflow-y: auto;
`;

export const ScrollComponent = styled.div<{
  hasScroll: boolean;
  maxHeight: number;
  filterMaxHeight: string;
}>`
  width: 100%;
  height: ${({ maxHeight }) => maxHeight}px;
  max-height: ${({ maxHeight, filterMaxHeight }) =>
    `calc(${maxHeight < innerHeight ? maxHeight : innerHeight}px - (168px + 56px + ${filterMaxHeight} + 16px + 24px))`};
  padding: ${({ hasScroll }) => (hasScroll ? `0 10px 16px 24px` : `0 24px 16px 24px`)};
  overflow: auto;
`;

export const AvatarWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  & .sendbird-avatar-img--default {
    background-color: ${({ theme }) => theme.colors.neutral['300']};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
